// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"854afac6","977":"29500f29"}[chunkId] + ".chunk.js";
};